import { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import Select from 'react-select';
import { getStratigraphyLexicons, selectStratigraphy } from "../../../services/stratigraphySlice";
import { useAppDispatch } from "../../../app/hooks";
import Errors from "../../errors"

const StratigraphyAdd = (props: any) => {

  const { 
        addStratigraphyValue,
        depthUnit
     } = props;

  const unitLabel = depthUnit === 2 ? "ft" : "m";

  const dispatch = useAppDispatch();   
  
  const { 
    stratigraphyLexicons,
    error,
    loading,
    lexiconsLoaded
  } = useSelector(selectStratigraphy);  

  useEffect(() => {
    if (!lexiconsLoaded) {
      dispatch(getStratigraphyLexicons());
    }
  }, [lexiconsLoaded]);

  const stratigraphyLexiconOptions = stratigraphyLexicons.map((lexicon: any) => { return { value: lexicon.id, label: <><div className='lithology-select-box' style={{backgroundColor: lexicon.color}}></div>{lexicon.description}</> } });

  const [fromDepth, setFromDepth] = useState<number| undefined>(undefined);
  const [toDepth, setToDepth] = useState<number | undefined>(undefined);
  const [selectedStratigraphyLexiconId, setSelectedStratigraphyLexiconId] = useState<any>();
  const [errors, setErrors] = useState<string[]>([]);

  const onSetFromDepth = (e: any) => {
    const validated = e.target.value.match(/^(\d*[.,]{0,1}\d{0,2}$)/)
    if (!validated) {
       return;
    }

    setFromDepth(+e.target.value);
  };

  const onSetToDepth = (e: any) => {
    const validated = e.target.value.match(/^(\d*[.,]{0,1}\d{0,2}$)/)
    if (!validated) {
       return;
    }

    setToDepth(+e.target.value);
  };

  const onLexiconChange = (item: any) => {        
    const stratigraphyLexiconId = item.value;
    setSelectedStratigraphyLexiconId(stratigraphyLexiconId);
  }
  

  const onAdd = () => {    
    let errored = false;
    let localErrors = [];
    
    if (fromDepth === undefined) {      
      localErrors.push("'From' cannot be empty.");
      errored = true;
     }
    
    if (toDepth === undefined) {      
      localErrors.push("'To' cannot be empty.");
      errored = true;
     } 

     if (toDepth !== undefined && fromDepth !== undefined && toDepth <= fromDepth) {      
      localErrors.push("'To' must be greater than 'From'.");
      errored = true;
     } 

     if (!selectedStratigraphyLexiconId) {
        localErrors.push("'Lexicon' cannot be empty.");
        errored = true;
     } 

     if (errored) {
      setErrors(localErrors);
      return;
     }

     //find lexicon description
     const lexicon = stratigraphyLexicons.find((l: any) => l.id === selectedStratigraphyLexiconId);

     const fromDepthMeters = depthUnit === 2 ? fromDepth! / 3.2808 : fromDepth!;
     const toDepthMeters = depthUnit === 2 ? toDepth! / 3.2808 : toDepth!;

      if (addStratigraphyValue(fromDepthMeters, toDepthMeters, lexicon)) {
        setErrors([]);
        setFromDepth(undefined);
        setToDepth(undefined);
        setSelectedStratigraphyLexiconId(undefined);
      } else {
        setErrors(["Depth range cannot overlap with existing."]);
      }    
  };

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,          
      backgroundColor: state.isSelected ? '#AAAAAA' : '#FFFFFF',
      padding: 5,
      paddingLeft: "12px"
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })        
  }

  const selectedValue = stratigraphyLexiconOptions.find((option: any) => option.value == selectedStratigraphyLexiconId);

  return (  
          <div>
            {errors.length > 0 && <Errors error={{ errors: {"": errors }}} />}
            <table className='text-edit-table'>
            <thead>
                  <tr>
                    <th>From ({unitLabel})</th>
                    <th>To ({unitLabel})</th>
                    <th>Lexicon</th>
                  </tr>
                </thead>
              <tbody>                
                <tr>
                  <td><input type="number" className={`input `} style={{maxWidth: "80px"}} value={fromDepth} onChange={onSetFromDepth} /></td>
                  <td><input type="number" className={`input `} style={{maxWidth: "80px"}} value={toDepth} onChange={onSetToDepth} /></td>
                  <td>
                  <Select options={stratigraphyLexiconOptions} styles={customStyles} classNamePrefix="select" value={selectedValue} onChange={(value: any) => onLexiconChange(value)} />
                  </td>
                </tr>
              </tbody>
            </table>
            <button className="button mr-2" onClick={onAdd}>Add</button>
            
          </div>       
)}

export default StratigraphyAdd;